import { BASE_URL } from '../common/constants/AppConstants';
import { baseGetAPICall, getAPICall, getAPICallWithParams, postAPICall, putAPICall, deleteAPICall } from './BaseAPI';

export const getDrivers = (cb=(jR, s, e)=>{}) => {
  getAPICall('user/getdrivers/', cb);
}

export const getActiveUsers = (cb=(jR, s, e)=>{}) => {
  getAPICall('user/getactiveusers/', cb);
}

export const getUsers = (params = {}, cb = (jR, s, e) => {}) => {
  getAPICallWithParams('user', params, cb);
}

export const getUserById = (id, cb = (jR, s, e) => {}) => {
  getAPICall(`user/${id}`, cb);
}

export const createUser = (payload, cb = (jR, s, e) => {}) => {
  postAPICall('user', payload, cb);
}

export const updateUser = (id, payload, cb = (jR, s, e) => {}) => {
  putAPICall(`user/${id}`, payload, cb);
}

export const deleteUser = (id, cb = (jR, s, e) => {}) => {
  deleteAPICall(`user/${id}`, cb);
}

export const getAllPermissions = (cb = (jR, s, e) => {}) => {
  getAPICall('permission/all', cb);
}

